import React from "react";

import useScrollToTop from "../../../hooks/useScollToTop";

import AdherentStats from "./components/AdherentStats";
import AdherentFilters from "./components/AdherentFilters";
import AdherentsTable from "./components/AdherentsTable";
import AdherentsMobileList from "./components/AdherentsMobileList";
import AdherentDetailsDrawer from "./components/AdherentDetailsDrawer";
import AdherentPagination from "./components/AdherentPagination";
import AdherentsSkeleton from "./components/AdherentsSkeleton";
import AdherentsEmptyState from "./components/AdherentsEmptyState";

import { useAdminAdherents } from "./hooks/useAdminAdherents";

function AdherentsAdmin() {
  useScrollToTop();

  const {
    filteredAdherents,
    paginatedAdherents,
    filters,
    stats,
    clubOptions,
    departementOptions,
    selectedAdherent,
    isDrawerOpen,
    loading,
    refreshing,
    page,
    totalPages,
    fetchAdherents,
    updateFilter,
    resetFilters,
    setPage,
    openAdherentDrawer,
    closeAdherentDrawer,
  } = useAdminAdherents();

  const hasFilters = Boolean(
    filters.search ||
      filters.genre ||
      filters.departement ||
      filters.club ||
      filters.licence,
  );

  return (
    <div className="w-full space-y-6 font-satoshi">
      {loading ? (
        <AdherentsSkeleton />
      ) : (
        <>
          <AdherentStats stats={stats} />

          <AdherentFilters
            filters={filters}
            clubOptions={clubOptions}
            departementOptions={departementOptions}
            refreshing={refreshing}
            onChange={updateFilter}
            onReset={resetFilters}
            onRefresh={() => fetchAdherents({ silent: false })}
          />

          {paginatedAdherents.length > 0 ? (
            <>
              <AdherentsTable
                adherents={paginatedAdherents}
                onOpen={openAdherentDrawer}
              />

              <AdherentsMobileList
                adherents={paginatedAdherents}
                onOpen={openAdherentDrawer}
              />

              <AdherentPagination
                page={page}
                totalPages={totalPages}
                perPage={filters.perPage}
                totalItems={filteredAdherents.length}
                onPageChange={setPage}
                onPerPageChange={updateFilter}
              />
            </>
          ) : (
            <AdherentsEmptyState
              hasFilters={hasFilters}
              onReset={resetFilters}
            />
          )}

          <AdherentDetailsDrawer
            isOpen={isDrawerOpen}
            adherent={selectedAdherent}
            onClose={closeAdherentDrawer}
          />
        </>
      )}
    </div>
  );
}

export default AdherentsAdmin;